import { IconTypes } from '@eika/icon';
import { useTranslation } from '@translations';
import './start-saving-now.scss';
import { useDataAttributes } from '@data-attributes/use-data-attributes';
import { useAppConfig } from '@default-config';
import { MarketCard, ShortcutCard } from '@eika/card';
import { useLinks } from '@hooks/use-links';

export const StartSavingNow = () => (
    <MarketCard header={<Header />} className="start-saving-now">
        <div className="start-saving-now__shortcuts">
            <SaveInFundShortcut />
            <ContactAdvisorShortcut />
        </div>
    </MarketCard>
);

const Header = () => {
    const { startSavingNow } = useTranslation();

    return <h3 className="start-saving-now__header">{startSavingNow.title}</h3>;
};

const SaveInFundShortcut = () => {
    const { startSavingNow } = useTranslation();
    const { saveInFund } = useLinks();
    const { saveInFundButtonDataAttrs } = useDataAttributes();

    return (
        <ShortcutCard
            text={startSavingNow.saveInFund}
            icon={IconTypes.SPAREGRIS_36}
            link={saveInFund.url}
            {...saveInFundButtonDataAttrs}
        />
    );
};

const ContactAdvisorShortcut = () => {
    const { startSavingNow } = useTranslation();
    const { contactAdvisor } = useLinks();
    const { contactAdvisorButtonDataAttrs } = useDataAttributes();
    const { bankConfig } = useAppConfig();

    if (!bankConfig.showContactAdvisorButton) {
        return null;
    }

    return (
        <ShortcutCard
            text={startSavingNow.contactAdvisor}
            icon={IconTypes.RADGIVING_36}
            link={contactAdvisor.url}
            {...contactAdvisorButtonDataAttrs}
        />
    );
};
